import type {OrderReportTripTracking, OrderStatusVendor} from '../../types';

import {Map} from '@Map';
import BikerIcon from 'assets/icons/orderSteps/BikerIcon.svg';
import VendorPin from 'assets/images/map/vendor-pin.svg';
import {Marker} from 'react-map-gl/maplibre';

type OrderStatusMapProps = {
  vendorAttributes?: OrderStatusVendor['attributes'];
  tracking?: OrderReportTripTracking;
};

const OrderStatusMap: React.FC<OrderStatusMapProps> = ({vendorAttributes, tracking}) => {
  const vendorLatitude = vendorAttributes?.latitude;
  const vendorLongitude = vendorAttributes?.longitude;

  return (
    <div className="flex h-dvh w-full">
      <Map
        centerLat={vendorLatitude == null ? 0 : vendorLatitude - 0.013}
        centerLong={vendorLongitude == null ? 0 : vendorLongitude - 0.0025}
        zoom={13}
      >
        <>
          {vendorLatitude != null && vendorLongitude != null ? (
            <Marker longitude={vendorLongitude} latitude={vendorLatitude}>
              <img className="size-20" src={VendorPin} alt="موقعیت فروشگاه" />
            </Marker>
          ) : null}
          {tracking?.longitude != null && tracking.latitude != null ? (
            <Marker longitude={tracking.longitude} latitude={tracking.latitude}>
              <img className="size-20" src={BikerIcon} alt="موقعیت پیک" />
            </Marker>
          ) : null}
        </>
      </Map>
    </div>
  );
};

export default OrderStatusMap;
